var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8904 29C10.8904 29 0.733307 15.7615 0.733307 10.15C0.733307 8.81708 0.996027 7.49722 1.50647 6.26576C2.01691 5.03431 2.76507 3.91538 3.70824 2.97287C4.65141 2.03035 5.77112 1.28271 7.00343 0.772623C8.23575 0.262537 9.55653 0 10.8904 0C12.2242 0 13.545 0.262537 14.7773 0.772623C16.0096 1.28271 17.1293 2.03035 18.0725 2.97287C19.0157 3.91538 19.7638 5.03431 20.2743 6.26576C20.7847 7.49722 21.0474 8.81708 21.0474 10.15C21.0474 15.7615 10.8904 29 10.8904 29ZM10.8904 13.05C11.66 13.05 12.3982 12.7445 12.9424 12.2006C13.4866 11.6568 13.7924 10.9191 13.7924 10.15C13.7924 9.38087 13.4866 8.64325 12.9424 8.09939C12.3982 7.55553 11.66 7.25 10.8904 7.25C10.1207 7.25 9.38257 7.55553 8.83834 8.09939C8.2941 8.64325 7.98836 9.38087 7.98836 10.15C7.98836 10.9191 8.2941 11.6568 8.83834 12.2006C9.38257 12.7445 10.1207 13.05 10.8904 13.05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationf);
export default __webpack_public_path__ + "static/media/locationf.3ce9e9c0f736d3cf8c4daed80afef34c.svg";
export { ForwardRef as ReactComponent };